(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["currency-symbol-clarity"] && !Shopify.designMode) return;
  try {
    (() => {
    const currencyCode = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    const prefix = {
      AUD: 'A$',
      CAD: 'CA$',
      NZD: 'NZ$',
      SGD: 'S$',
    }[currencyCode];

    if (!prefix) return;

    const pricePattern = /(^|[^A-Z])\$(?=\s?\d)/g;
    const excludedParents = 'script, style, textarea';

    const formatTextNode = (node) => {
      if (node.parentElement && node.parentElement.closest(excludedParents)) return;

      const currentValue = node.nodeValue;
      const nextValue = currentValue.replace(pricePattern, (match, leadingCharacter) => {
        return `${leadingCharacter}${prefix}`;
      });

      if (nextValue !== currentValue) node.nodeValue = nextValue;
    };

    const formatNode = (root) => {
      if (root.nodeType === Node.TEXT_NODE) {
        formatTextNode(root);
        return;
      }

      if (root.nodeType !== Node.ELEMENT_NODE) return;

      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let textNode;

      while ((textNode = walker.nextNode())) {
        formatTextNode(textNode);
      }
    };

    formatNode(document.body);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          formatTextNode(mutation.target);
          return;
        }

        mutation.addedNodes.forEach(formatNode);
      });
    }).observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["style-it-with"] && !Shopify.designMode) return;
  try {
    /* HfH Style It With v2.0.1. Normal cart lines; no discounts, inventory writes or retries. */
if (!customElements.get('hfh-style-it-with')) {
  class HfhStyleItWith extends HTMLElement {
    static active = null;
    static pendingKey = 'hfh.siw.pending.v2';
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected && !this.connected) this.connect(); });
    }
    connect() {
      const strings = this.querySelector('[data-siw-strings]');
      if (!strings) return;
      try { this.text = JSON.parse(strings.textContent); } catch (_) { return; }
      this.connected = true;
      this.epoch = (this.epoch || 0) + 1;
      this.events = new AbortController();
      this.unsubscribers = [];
      this.busy = false;
      this.cartKnown = false;
      this.cartLoading = false;
      this.cart = null;
      this.locked = this.hasPending();
      this.button = this.querySelector('[data-siw-add]');
      this.message = this.querySelector('[data-siw-message]');
      this.summary = this.querySelector('[data-siw-summary]');
      this.purchase = this.querySelector('[data-siw-purchase]');
      this.cartLink = this.querySelector('[data-siw-cart-link]');
      this.rail = this.querySelector('[data-siw-rail]');
      this.nav = this.querySelector('[data-siw-nav]');
      this.info = this.closest('product-info');
      this.cards = [...this.querySelectorAll('[data-siw-card]')].map(el => {
        const select = el.querySelector('[data-siw-select]');
        return { el, select, box: el.querySelector('[data-siw-include]'),
          current: el.dataset.current === 'true', special: el.dataset.special === 'true',
          coming: el.dataset.comingSoon === 'true', pending: false, ack: null,
          intent: el.querySelector('[data-siw-include]').checked,
          title: el.querySelector('[data-siw-title]').textContent.trim(),
          variants: [...select.options].filter(o => o.value).map(o => ({
            id: String(o.value), title: o.dataset.title, displayTitle: o.dataset.displayTitle, price: Number(o.dataset.price),
            available: o.dataset.available === 'true', supported: o.dataset.supported === 'true',
            max: o.dataset.max ? Number(o.dataset.max) : null, image: o.dataset.image || '', option: o
          })) };
      });
      this.main = this.cards.find(c => c.current);
      const on = (node, event, handler, capture = false) => node?.addEventListener(event, handler, { signal: this.events.signal, capture });
      on(this, 'change', e => this.change(e));
      on(this, 'click', e => {
        if (e.target.closest('[data-siw-add]')) this.add();
        if (e.target.closest('[data-siw-change]')) this.focusMain();
        const arrow = e.target.closest('[data-siw-direction]');
        if (arrow) this.rail.scrollBy({ left: Number(arrow.dataset.siwDirection) * 188, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        if (e.target.closest('[data-siw-cart-link]')) this.clearPending();
      });
      on(this.rail, 'scroll', () => this.updateNav());
      on(this.rail, 'focusin', e => e.target.closest('[data-siw-card]')?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' }));
      on(window, 'pageshow', () => { if (!this.busy) this.refreshCart(); });
      on(document, 'submit', e => {
        // Serialize normal product-form submissions during this module's write.
        if (!HfhStyleItWith.active || !e.target.matches('form[action*="/cart/add"]')) return;
        e.preventDefault(); e.stopImmediatePropagation();
      }, true);
      on(this.info, 'change', e => {
        if (e.target.matches('input[name="id"]') && !this.contains(e.target) && !e.target.value) this.setCurrent(null);
      });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.variantChange, event => {
          if (String(event?.data?.sectionId) !== this.dataset.sectionId) return;
          this.setCurrent(event.data.variant, event.data.html);
        }));
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, event => {
          if (!this.main || !this.info?.contains(event?.data?.event?.target)) return;
          this.main.pending = true;
          this.main.select.value = '';
          this.render();
        }));
        this.unsubscribers.push(subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
          if (event?.source !== 'hfh-style-it-with' && !this.busy) this.refreshCart();
        }));
      }
      // This theme returns early on a null variant, without publishing variantChange.
      // Inspect ONLY replacement variant pickers, never our own DOM mutations.
      if (this.info) {
        this.observer = new MutationObserver(records => {
          for (const r of records) for (const node of r.addedNodes) {
            if (node.nodeType !== 1 || this.contains(node)) continue;
            const picker = node.matches('variant-selects') ? node : node.querySelector('variant-selects');
            const data = picker?.querySelector('[data-selected-variant]');
            if (data) { try { this.setCurrent(JSON.parse(data.textContent)); } catch (_) { this.setCurrent(null); } }
          }
        });
        this.observer.observe(this.info, { childList: true, subtree: true });
      }
      if (typeof ResizeObserver !== 'undefined') {
        this.resize = new ResizeObserver(() => this.updateNav());
        this.resize.observe(this.rail);
      }
      this.dataset.ready = 'true';
      this.render();
      this.refreshCart();
      this.updateNav();
    }
    disconnectedCallback() {
      this.connected = false;
      this.epoch = (this.epoch || 0) + 1;
      this.events?.abort();
      this.unsubscribers?.forEach(fn => fn?.());
      this.observer?.disconnect(); this.resize?.disconnect();
    }
    t(key, params = {}) {
      let value = this.text[key] || '';
      for (const [name, replacement] of Object.entries(params)) value = value.split(`{${name}}`).join(String(replacement));
      return value;
    }
    variant(card) { return card.variants.find(v => v.id === card.select.value) || null; }
    normal(line) { return !line.selling_plan_allocation && Object.keys(line.properties || {}).length === 0; }
    quantity(cart, id) { return (cart?.items || []).filter(l => String(l.variant_id || l.id) === String(id) && this.normal(l)).reduce((n, l) => n + l.quantity, 0); }
    allowed(card, variant) {
      return !!variant && !card.special && variant.available && variant.supported &&
        (variant.max === null || this.quantity(this.cart, variant.id) + 1 <= variant.max);
    }
    anyAllowed(card) { return card.variants.some(v => this.allowed(card, v)); }
    money(value) {
      // Shopify appends two decimal places even for JPY/KRW; Intl supplies currency precision.
      const amount = Number(value) / 100;
      const currency = this.cart?.currency || this.dataset.currency;
      const format = new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang || 'en', { style: 'currency', currency });
      const digits = format.resolvedOptions().maximumFractionDigits;
      return new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency,
        minimumFractionDigits: Number.isInteger(amount) ? 0 : digits, maximumFractionDigits: digits }).format(amount);
    }
    change(event) {
      const card = this.cards.find(c => c.el.contains(event.target));
      if (!card || this.busy || this.locked) return;
      this.show('');
      card.el.querySelector('[data-siw-card-error]').hidden = true;
      card.select.removeAttribute('aria-invalid');
      if (event.target === card.select) {
        card.ack = null;
        const v = this.variant(card);
        if (v && this.quantity(this.cart, v.id)) card.box.checked = false;
      }
      if (event.target === card.box) {
        card.intent = card.box.checked;
        const v = this.variant(card);
        card.ack = card.box.checked && v && this.cartKnown ? { id: v.id, quantity: this.quantity(this.cart, v.id) } : null;
      }
      this.render();
    }
    setCurrent(raw, html) {
      const c = this.main;
      if (!c) return;
      c.pending = false;
      const id = raw?.id ? String(raw.id) : '';
      const next = c.variants.find(v => v.id === id);
      if (next) {
        const fresh = html?.querySelector('hfh-style-it-with [data-current="true"]');
        const option = fresh ? [...fresh.querySelectorAll('option')].find(o => o.value === id) : null;
        next.price = Number(raw.price);
        next.available = option ? option.dataset.available === 'true' : raw.available === true;
        if (option) {
          next.supported = option.dataset.supported === 'true';
          next.max = option.dataset.max ? Number(option.dataset.max) : null;
          next.image = option.dataset.image || '';
        } else if (raw.featured_image?.src) next.image = raw.featured_image.src;
      }
      if (c.select.value !== id) c.ack = null;
      c.select.value = next ? id : '';
      c.box.checked = !!next && c.intent && this.allowed(c, next);
      if (next && this.quantity(this.cart, id) > 0 && c.ack?.id !== id) c.box.checked = false;
      this.render();
    }
    render() {
      if (!this.connected) return;
      let total = 0, count = 0, missing = false, sizesOnly = true;
      for (const c of this.cards) {
        const v = this.variant(c);
        const qty = v ? this.quantity(this.cart, v.id) : 0;
        const canChoose = !c.pending && (v ? this.allowed(c, v) : !c.current && this.anyAllowed(c));
        if (!canChoose) c.box.checked = false;
        c.box.disabled = !canChoose || this.busy || this.locked;
        c.select.disabled = this.busy || this.locked || !this.anyAllowed(c);
        for (const option of c.variants) option.option.disabled = !this.allowed(c, option);
        c.el.querySelector('[data-siw-price]').textContent = !v && c.el.dataset.priceVaries === 'true'
          ? this.t('from', { price: this.money(Number(c.el.dataset.minPrice)) }) : this.money(v?.price ?? Number(c.el.dataset.minPrice));
        const image = c.el.querySelector('img');
        if (image && v?.image && image.getAttribute('src') !== v.image) { image.removeAttribute('srcset'); image.src = v.image; }
        const choice = c.el.querySelector('[data-siw-choice]');
        if (choice) choice.textContent = v ? (v.title === 'Default Title' ? this.t('one_size') : (v.displayTitle || v.title)) : this.t(c.pending ? 'pending_options' : 'unavailable');
        let state = '';
        const unsupported = c.special || (!v && !c.variants.some(x => x.supported)) || (v && !v.supported) || (v && v.max !== null && qty + 1 > v.max);
        if (c.pending) state = this.t('pending_options');
        else if (unsupported) state = this.t('personalization');
        else if ((v && !v.available) || (!v && !c.variants.some(x => x.available))) state = this.t(c.coming ? 'coming_soon' : 'sold_out');
        else if (!v && c.current) state = this.t('unavailable');
        else if (qty > 0) state = this.t('in_cart');
        c.el.querySelector('[data-siw-state]').textContent = state;
        c.el.querySelector('[data-siw-include-text]').textContent = this.t(qty > 0 ? 'one_more' : 'include');
        // A wholly unavailable card is editorial, not a broken-looking purchase form.
        // Keep hidden controls in the DOM for exact-variant state; never loosen eligibility.
        const noPurchasableOptions = !this.anyAllowed(c) && !c.pending;
        c.el.querySelector('.hfh-siw-include').hidden = noPurchasableOptions || (c.current && !canChoose);
        c.el.querySelector('.hfh-siw-options').hidden = c.special || noPurchasableOptions;
        c.el.querySelector('[data-siw-details]').hidden = !(unsupported || noPurchasableOptions);
        if (c.box.checked) {
          count++;
          if (!v) { missing = true; sizesOnly = sizesOnly && c.el.dataset.sizeOnly === 'true'; }
          else total += v.price;
        }
      }
      const useful = this.cards.some(c => !c.current && this.anyAllowed(c));
      this.purchase.hidden = !useful;
      this.summary.textContent = count ? this.t('count', { count }) + (missing ? '' : ` · ${this.money(total)}`) : '';
      let label = this.t('select_item');
      if (count) label = missing ? this.t(sizesOnly ? 'choose_size' : 'choose_options') : `${this.t('add_selected')} · ${this.money(total)}`;
      const pending = this.main?.pending && this.main.intent;
      if (pending) label = this.t('pending_options');
      if (!this.cartKnown) label = this.t(this.cartLoading ? 'cart_checking' : 'retry_check');
      if (this.busy) label = this.t(this.writing ? 'adding' : 'checking');
      if (this.locked) label = this.t('view_cart');
      this.button.textContent = label;
      this.button.disabled = this.busy || this.cartLoading || !!pending || (!count && this.cartKnown && !this.locked);
      this.button.setAttribute('aria-disabled', String(this.button.disabled));
      this.button.setAttribute('aria-busy', String(this.busy || !!this.cartLoading));
      this.toggleAttribute('data-busy', this.busy);
    }
    show(key, raw = false) {
      this.message.textContent = raw ? key : this.t(key);
      this.message.hidden = !key;
      this.cartLink.hidden = !['uncertain', 'added', 'display_error', 'rejected', 'duplicate'].includes(key);
    }
    focusMain() {
      const picker = this.info?.querySelector('variant-selects');
      const target = picker?.querySelector('input:checked:not(:disabled),select:not(:disabled),input:not(:disabled)');
      if (target) { picker.scrollIntoView({ block: 'center', behavior: 'auto' }); target.focus({ preventScroll: true }); }
    }
    updateNav() {
      if (!this.rail || !this.nav) return;
      const overflow = this.rail.scrollWidth - this.rail.clientWidth;
      this.nav.hidden = overflow < 3;
      const buttons = this.nav.querySelectorAll('button');
      if (buttons.length === 2) {
        buttons[0].disabled = this.rail.scrollLeft < 2;
        buttons[1].disabled = this.rail.scrollLeft >= overflow - 2;
      }
      this.cards?.forEach(c => { const img = c.el.querySelector('img'); if (img) img.sizes = `${Math.ceil(c.el.getBoundingClientRect().width)}px`; });
    }
    url(path) {
      const root = window.Shopify?.routes?.root || this.dataset.root || '/';
      return new URL(root.replace(/\/?$/, '/') + path, window.location.origin).toString();
    }
    async request(url, options = {}) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal });
        const data = await response.json();
        return { ok: response.ok, status: response.status, data };
      } finally { clearTimeout(timer); }
    }
    async readCart() {
      const r = await this.request(this.url('cart.js'));
      if (!r.ok || !Array.isArray(r.data?.items) || !r.data.currency) throw new Error('cart-read');
      return r.data;
    }
    applyCart(cart, resetIds = []) {
      this.cart = cart; this.cartKnown = true;
      for (const c of this.cards) {
        const v = this.variant(c); if (!v) continue;
        const qty = this.quantity(cart, v.id);
        if (resetIds.includes(v.id) || (qty > 0 && (c.ack?.id !== v.id || c.ack.quantity !== qty))) {
          c.box.checked = false; c.ack = null;
          if (c.current) c.intent = false;
        }
      }
      this.render();
    }
    async refreshCart() {
      if (this.cartLoading || this.busy || !this.connected) return;
      const epoch = this.epoch;
      this.cartLoading = true; this.render();
      try {
        const cart = await this.readCart();
        if (!this.connected || this.epoch !== epoch) return;
        this.applyCart(cart);
        if (this.locked) this.show('uncertain');
        else if (this.message.textContent === this.t('cart_error')) this.show('');
      } catch (_) {
        if (this.connected && this.epoch === epoch) { this.cartKnown = false; this.show(this.locked ? 'uncertain' : 'cart_error'); }
      } finally {
        if (this.connected && this.epoch === epoch) { this.cartLoading = false; this.render(); }
      }
    }
    hasPending() { try { return !!sessionStorage.getItem(HfhStyleItWith.pendingKey); } catch (_) { return false; } }
    markPending(ids) { try { sessionStorage.setItem(HfhStyleItWith.pendingKey, JSON.stringify({ at: Date.now(), ids })); } catch (_) {} }
    clearPending() { try { sessionStorage.removeItem(HfhStyleItWith.pendingKey); } catch (_) {} }
    fingerprint(cart) {
      const lines = new Map();
      for (const l of cart.items) {
        const props = Object.entries(l.properties || {}).sort(([a], [b]) => a.localeCompare(b));
        const key = JSON.stringify([String(l.variant_id || l.id), l.selling_plan_allocation?.selling_plan?.id || null, props]);
        lines.set(key, (lines.get(key) || 0) + l.quantity);
      }
      return JSON.stringify([cart.currency, cart.note || '', Object.entries(cart.attributes || {}).sort(), [...lines].sort()]);
    }
    async checkProduct(card) {
      const url = new URL(card.el.dataset.url, location.origin);
      if (url.origin !== location.origin) throw new Error('product-origin');
      url.pathname = url.pathname.replace(/\.js$/, '') + '.js'; url.search = '';
      const result = await this.request(url.toString());
      const data = result.data;
      if (!result.ok || !Array.isArray(data?.variants)) throw new Error('product-read');
      let changed = false;
      card.coming = Array.isArray(data.tags) ? data.tags.includes('coming-soon') : card.coming;
      if (data.requires_selling_plan === true || data.gift_card === true) card.special = true;
      for (const v of card.variants) {
        const fresh = data.variants.find(x => String(x.id) === v.id);
        const available = fresh?.available === true;
        if (card.select.value === v.id && (!available || Number(fresh.price) !== v.price)) changed = true;
        v.available = available;
        if (fresh) {
          v.price = Number(fresh.price);
          if (fresh.requires_selling_plan === true) v.supported = false;
        }
      }
      if (Number.isFinite(data.price_min)) card.el.dataset.minPrice = String(data.price_min);
      return changed;
    }
    selected() { return this.cards.filter(c => c.box.checked).map(c => ({ card: c, variant: this.variant(c) })); }
    async add() {
      if (this.locked) { this.clearPending(); location.assign(this.url('cart')); return; }
      if (this.busy || this.cartLoading || HfhStyleItWith.active) return;
      if (!this.cartKnown) { this.refreshCart(); return; }
      const selected = this.selected();
      if (!selected.length) return;
      const missing = selected.find(x => !x.variant);
      if (missing) {
        const error = missing.card.el.querySelector('[data-siw-card-error]');
        error.textContent = this.t('choose_error'); error.hidden = false;
        missing.card.select.setAttribute('aria-invalid', 'true');
        if (missing.card.current) this.focusMain(); else missing.card.select.focus();
        return;
      }
      const items = selected.map(x => ({ id: x.variant.id, quantity: 1 }));
      HfhStyleItWith.active = this;
      this.busy = true; this.writing = false; this.show(''); this.render();
      let before = null, attempted = false, confirmed = false, result = null;
      try {
        before = await this.readCart();
        if (before.currency !== this.dataset.currency) { this.show('changed'); return; }
        const duplicate = selected.some(({ card, variant }) => {
          const qty = this.quantity(before, variant.id);
          return qty > 0 && (card.ack?.id !== variant.id || card.ack.quantity !== qty);
        });
        this.applyCart(before);
        if (duplicate) { this.show('duplicate'); return; }
        const mainForm = this.info?.querySelector('product-form form');
        if (selected.some(x => x.card.current) && mainForm?.querySelector('[name^="properties["]')) {
          this.show('personalization'); this.focusMain(); return;
        }
        let changed;
        try { changed = (await Promise.all(selected.map(x => this.checkProduct(x.card)))).some(Boolean); }
        catch (_) { this.show('product_error'); return; }
        if (changed || selected.some(({ card, variant }) => card.select.value !== variant.id || !card.box.checked || !this.allowed(card, variant))) {
          this.show('changed'); return;
        }
        const drawer = document.querySelector('cart-drawer');
        const body = { items };
        if (drawer?.getSectionsToRender) {
          body.sections = drawer.getSectionsToRender().map(s => s.id).slice(0, 5);
          body.sections_url = location.pathname;
          drawer.setActiveElement?.(this.button);
        }
        this.writing = true; this.render();
        this.markPending(items.map(x => x.id));
        attempted = true;
        result = await this.request(this.url('cart/add.js'), {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body)
        });
        confirmed = result.ok && !result.data?.status && Array.isArray(result.data?.items) &&
          items.every(i => result.data.items.some(l => String(l.variant_id || l.id) === i.id));
        if (!confirmed) { await this.reconcile(before, result); return; }
        this.clearPending();
        selected.forEach(({ card }) => { card.box.checked = false; card.intent = false; card.ack = null; });
        this.show('added');
        try { this.applyCart(await this.readCart(), items.map(x => x.id)); }
        catch (_) { this.cartKnown = false; this.show('display_error'); }
        // A UI failure after a confirmed add must NEVER enter a mutation retry path.
        const rendered = await this.renderCart(drawer, result.data);
        if (!rendered) this.show('display_error');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hfh-style-it-with', cartData: result.data });
        }
      } catch (_) {
        if (attempted && !confirmed) await this.reconcile(before, result);
        else this.show(confirmed ? 'display_error' : 'cart_error');
      } finally {
        this.busy = false; this.writing = false;
        if (HfhStyleItWith.active === this) HfhStyleItWith.active = null;
        this.render();
      }
    }
    async reconcile(before, result) {
      this.locked = true; // Abort/timeout does not prove that Shopify rejected the write.
      let after = null;
      try { after = await this.readCart(); this.applyCart(after); } catch (_) { this.cartKnown = false; }
      const definitiveRejection = result && [400, 404, 422].includes(result.status) && result.data?.status;
      if (definitiveRejection && before && after && this.fingerprint(before) === this.fingerprint(after)) {
        this.locked = false; this.clearPending(); this.show('rejected');
      } else {
        // Includes partial writes and concurrent changes. No rollback and no automatic resubmission.
        this.show('uncertain');
      }
    }
    async renderCart(drawer, state) {
      if (!drawer?.getSectionsToRender || !drawer?.renderContents) return false;
      const sections = drawer.getSectionsToRender();
      const valid = map => sections.every(s => {
        if (typeof map?.[s.id] !== 'string') return false;
        return !!new DOMParser().parseFromString(map[s.id], 'text/html').querySelector(s.selector || '.shopify-section');
      });
      try {
        if (!valid(state.sections)) {
          const url = new URL(location.href); url.searchParams.set('sections', sections.map(s => s.id).join(','));
          const refreshed = await this.request(url.toString());
          if (!refreshed.ok || !valid(refreshed.data)) return false;
          state.sections = refreshed.data;
        }
        drawer.classList.remove('is-empty');
        drawer.renderContents(state);
        return true;
      } catch (_) { return false; }
    }
  }
  customElements.define('hfh-style-it-with', HfhStyleItWith);
}
  } catch(e) { console.error(e); }
})();

})();
